// extracted by mini-css-extract-plugin
export default {"container":"RenderIframe_container__CSU1K","card-container":"RenderIframe_card-container__IdBvU"};